module.exports = __webpack_public_path__ + "images/earnMorePoints_666b392.svg";